import { Injectable } from "@angular/core";
import { Observable, catchError, map } from "rxjs";
import { LoginUserDto } from "../../models/auth/login-user.dto";
import { TokenService } from "./token.service";
import { urlServicesAuth } from '../../constants/auth.constants';
import { UserStorageService } from '../local/user-storage.service';
import { RestService } from "../communication-rest/communication-rest.service";
import { ResponseDto } from "../../models/generic/response.dto";
import { HttpErrorCodeService } from "../../shared/error/http-error-code";
import { JSONHelper } from '../../shared/helpers/json.helper';
import { SignatureRequest } from "../../models/cross-functions/double-signature/signature-request.dto";
import { SignatureResponse } from "../../models/cross-functions/double-signature/signature-response.dto";

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    url = urlServicesAuth;
    constructor(protected restService : RestService, 
        protected tokenService: TokenService,
        protected userStorageService : UserStorageService){
    }

    login(userAuth: LoginUserDto):Observable<any>{    
        return this.restService.post<ResponseDto>(this.url.auth, userAuth)
            .pipe(
                map( resp => {
                    let authorized: boolean = false;
                    let msg: string = '';
                    const res = this.restService.getResultResponse(resp, '', false);

                    switch (res.response.code) {
                        case -1://Código para contraseña incorrecta
                            msg = 'msg_invalid'
                            break;
                        case -2://Código para usuario no existente
                            msg = 'msg_usuario_valido'
                            break;
                        case -3:
                            msg = 'Acceso no autorizado, verifique su información'
                            break;
                        case -4:
                            msg = 'msg_usuario_bloqueado'
                            break;
                        case -5:
                            msg = 'msg_esperar_10_min'
                            break;
                        case -6:
                            msg = 'msg_usuario_bloqueado'
                            break;                    
                        default: //code 0 : Access Authorized
                            authorized = true;
                            msg = ' ';
                            this.userStorageService.saveUser(res.user);
                            this.tokenService.saveToken(res.token);
                            this.tokenService.saveRefreshToken(JSONHelper.getDataByKey(res, "refreshed-token"));
                            break;
                    }
                    return { authorized : authorized, msg : msg };
                }),
                catchError((error) => {
                    let errorMessage = HttpErrorCodeService.getMessage(error);
                    throw errorMessage;
                })
            );
    }

    refreshToken(oldToken: string){
        return this.restService.post<ResponseDto>(this.url.refresh, oldToken, true)
            .pipe(
                map(res => {
                    let response = this.restService.getResultResponse(res, "", false);
                    this.tokenService.saveRefreshToken(response.data);
                    return response.data;
                }),
                catchError((error) => {
                    let errorMessage = HttpErrorCodeService.getMessage(error);
                    throw errorMessage;
                })
            )
    }

    signdProcess(signatureRequest: SignatureRequest): Observable<SignatureResponse>{
        return this.restService.post<SignatureResponse>(this.url.doubleSignature, signatureRequest);
    }
}